import css from './SubmitBookingPanel.module.css';
import { NamedLink } from '../../index';
import { SWLink } from '../../mui/Link';
import { FormattedMessage } from '../../../util/reactIntl';
import React from 'react';
import classNames from 'classnames';

export const DigitalPurchasedNote = ({ rootClassName, messageId }) => {
  const rootClasses = classNames(css.digitalPurchasedNote, rootClassName);
  return (
    <p className={rootClasses} data-testid="digital-purchased-note">
      <FormattedMessage id={messageId || 'BookedNote.digitalAlreadyPurchased'} />
    </p>
  );
};

export const BookedNote = ({ bookingInfo, onCancelCurrentBooking, listing, rootClassName }) => {
  const rootClasses = classNames(rootClassName || css.bookingNoteContainer);

  // const cancelActions = () => {
  //   onCancelCurrentBooking({
  //     transactionId: bookingInfo?.currentBooking?.id,
  //     listingId: listing?.id?.uuid,
  //   });
  // };

  if (!bookingInfo?.isCurrentlyBooked) {
    return null;
  }

  const bookingNoteText = bookingInfo?.isFreeListing
    ? 'BookedNote.freeBookingDone'
    : bookingInfo?.isPayLaterListing
    ? 'BookedNote.payLaterBookingDone'
    : 'BookedNote.paidBookingDone';

  return (
    <section className={rootClasses}>
      <div className={css.bookingNote}>
        <div className={css.bookingNote_title}>
          <div className={css.bookingNote_title}>
            <FormattedMessage id={bookingNoteText} />
          </div>
        </div>
        <div className={css.bookingNote_body}>
          {bookingInfo?.isCurrentlyBooked ? (
            <div className={css.bookingNote_item}>
              <NamedLink
                className={css.bookingNote_link}
                name={'InboxPage'}
                params={{ tab: 'orders' }}
              >
                View bookings
              </NamedLink>
            </div>
          ) : null}

          {/*{bookingInfo?.isFreeListing || bookingInfo?.isPayLaterListing ? (*/}
          {/*  <div className={css.bookingNote_item_bordered}>*/}
          {/*    <span className={css.mr8}>Changed your mind?</span>*/}
          {/*    <SWLink*/}
          {/*      component="button"*/}
          {/*      onClick={() => {*/}
          {/*        cancelActions();*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <FormattedMessage id="BookingTimeForm.cancelBooking" />*/}
          {/*    </SWLink>*/}
          {/*  </div>*/}
          {/*) : null}*/}
        </div>
      </div>
    </section>
  );
};
